import categoriesItemRequests from '../../../../assets/icons/icon-request.svg';
import categoriesItemAutogestionables from '../../../../assets/icons/icon-autogestionables.svg';
import categoriesItemBecas from '../../../../assets/icons/icon-becas.svg';

const categories = {
  certificates: {
    id: 1,
    name: 'CERTIFICADOS',
    url: 'constancias',
    title: 'Constancias y Certificados',
    type1Ids: [1018, 1019, 1022, 1023, 1024, 1025, 1027, 1020],
    type1List: [
      {
        procedureId: 1018,
        name: 'Constancia de estudios',
        url: 'constancia-estudios',
        id: 'request_constancia_de_estudios'
      },
      {
        procedureId: 1019,
        name: 'Constancia de ingreso',
        url: 'constancia-ingreso',
        id: 'request_constancia_de_ingreso'
      },
      {
        name: 'Registro de fotografía',
        procedureId: 1020,
        url: 'registro-foto',
        id: 'request_registro_de_fotografia'
      },
      {
        procedureId: 1022,
        name: 'Constancia de pertenencia a tercio, quinto, décimo',
        url: 'constancia-pertenencia',
        id: 'request_constancia_de_pertenencia_a_tercio_quinto_decimo'
      },
      {
        procedureId: 1023,
        name: 'Constancia de promedio ponderado (periodo)',
        url: 'constancia-promedio-ponderado',
        id: 'request_constancia_de_promedio_ponderado_periodo'
      },
      {
        procedureId: 1024,
        name: 'Constancia de promedio ponderado acumulado',
        url: 'constancia-promedio-ponderado-acumulado',
        id: 'request_constancia_de_promedio_ponderado_acumulado'
      },
      {
        procedureId: 1025,
        name: 'Constancia de matrícula',
        url: 'constancia-matricula',
        id: 'request_constancia_de_matricula'
      },
      {
        procedureId: 1027,
        name: 'Constancia de adeudo / no adeudo',
        url: 'constancia-adeudo-no-adeudo',
        id: 'request_constancia_de_adeudo_no_adeudo'
      },
      {
        procedureId: 1032,
        name: 'Certificado de estudios',
        url: 'solicitud/certificado-de-estudios',
        id: 'request_certificado_de_estudios'
      },
      {
        procedureId: 1040,
        name: 'Constancia de egresado',
        url: 'solicitud/certificado-de-egresado',
        id: 'request_certificado_de_egresado'
      }
    ],
    type2List: []
  },
  requests: {
    id: 2,
    name: 'SOLICITUDES',
    url: 'solicitudes',
    title: 'Solicitudes',
    procedures: {
      bse: 1013,
      certificateOfStudies: 1032,
      changeCareerCampusModality: 1026,
      issuanceUniversityCard: 1030,
      changeOfStudyOptionModality: 1031,
      reincorporation: 1033,
      examStragglers: 1034,
      fullCycleDiscount: 1012,
      rectificationNotes: 1017,
      reinstatement: 9001,
      removeOfPeriod: 1021,
      retreatCourse: 1036,
      updatePhoto: 1020,
      validationCardVaccination: 9003,
      validationInsurance: 9002,
      pse: 1037,
      employabilityCharter: 1038,
      graduatedCertificated: 1040,
      scholarshipsDiscounts: 1039
    },
    procedureListTemp: [
      {
        isTemp: false,
        name: 'Cambio de modalidad',
        procedureId: 1031,
        url: 'cambio-opcion-estudio',
        id: 'request_cambio_de_modalidad'
      },
      // Reincorporación comentario para pase a prod
      {
        isTemp: false,
        name: 'Reincorporación',
        procedureId: 1033,
        url: 'reincorporacion',
        id: 'request_reincorporacion'
      },
      // Reincorporación comentario
      // {
      //   isTemp: true,
      //   name: 'Reincorporación',
      //   procedureId: 9001,
      //   url: 'reincorporacion',
      //   embeddedProps: {
      //     source: `${constants.PE_URL}${constants.PE_PATH_TRAMITES2}`,
      //     // params: ['emplid', 'grado', 'codutpalu','campus', 'strm'],
      //     params: ['codutpalu'],
      //     moduleName: 'Reincorporacion'
      //   }
      // },
      {
        isTemp: false,
        name: 'Validación de seguro',
        procedureId: 1037,
        url: 'validacion-seguro',
        isNew: true,
        id: 'request_validacion_de_seguro'
        // embeddedProps: {
        //   source: `${constants.PE_URL}${constants.PE_PATH_TRAMITES2}`,
        //   // params: ['emplid', 'grado', 'codutpalu', 'campus', 'strm'],
        //   params: ['codutpalu'],
        //   moduleName: 'ValidacionSeguroSalud'
        // }
      },
      // {
      //   isTemp: true,
      //   name: 'Validación de carné de vacunación',
      //   procedureId: 9003,
      //   url: 'validacion-carnet-vacunacion',
      //   embeddedProps: {
      //     source: `${constants.PE_URL}${constants.PE_PATH_TRAMITES2}`,
      //     params: ['emplid', 'grado', 'codutpalu','campus', 'strm'],
      //     moduleName: 'CarneVacunacion'
      //   }
      // },
      {
        isTemp: false,
        name: 'Descuento de ciclo completo (10%)',
        procedureId: 1012,
        url: 'descuento-ciclo-completo',
        isNew: false,
        id: 'request_descuento_de_ciclo_completo'
        /* embeddedProps: {
          source: `${constants.PE_URL}${constants.PE_PATH_TRAMITES2}`,
          // params: ['emplid', 'grado', 'codutpalu','campus', 'strm'],
          params: ['codutpalu'],
          moduleName: 'PagoAdelantado'
        } */
      },
      // {
      //   isTemp: true,
      //   name: 'Rectificación de notas',
      //   procedureId: 9005,
      //   url: 'rectificacion-notas',
      //   embeddedProps: {
      //     source: `${constants.PE_URL}${constants.PE_PATH_RECTIFICACIONES}`,
      //     params: ['emplid', 'grado', 'codutpalu']
      //   }
      // },
      {
        isTemp: false,
        name: 'Retiro de curso',
        procedureId: 1036,
        url: 'retiro-curso',
        isNew: false,
        id: 'request_retiro_de_curso'
        // embeddedProps: {
        //   source: `${constants.PE_URL}${constants.PE_PATH_TRAMITES2}`,
        //   // params: ['emplid', 'grado', 'codutpalu','campus', 'strm'],
        //   params: ['codutpalu'],
        //   moduleName: 'RetiroCurso'
        // }
      },
      {
        isTemp: false,
        name: 'Examen de rezagados',
        procedureId: 1034,
        url: 'examen-rezagado',
        id: 'request_examen_de_rezagados'
        // embeddedProps: {
        //   source: `${constants.PE_URL}${constants.PE_PATH_TRAMITES2}`,
        //   // params: ['emplid', 'grado', 'codutpalu','campus', 'strm'],
        //   params: ['codutpalu'],
        //   moduleName: 'ExamenRezagados'
        // }
      },
      {
        isTemp: false,
        name: 'Emisión de carné universitario',
        procedureId: 1030,
        url: 'emision-carnet-universitario',
        id: 'request_emision_de_carne_universitario'
      },
      {
        isTemp: false,
        name: 'Carta de presentación para práctica, empleo o internado',
        procedureId: 1038,
        url: 'emision-carta-empleabilidad',
        isNew: true,
        id: 'request_carta_de_presentacion_para_practica_empleo_o_internado'
      },
      {
        isTemp: false,
        name: 'Rectificación de nota',
        procedureId: 1017,
        url: 'rectificacion-de-notas',
        isNew: true,
        id: 'request_rectificacion_de_nota'
      },
      {
        isTemp: false,
        procedureId: 1021,
        name: 'Retiro de periodo lectivo',
        url: 'retiro-periodo-lectivo',
        id: 'request_retiro_de_periodo_lectivo'
      }
    ],
    procedureList: [
      // {
      //   isTemp: false,
      //   procedureId: 1026,
      //   name: 'Cambio de carrera, campus o modalidad',
      //   url: 'cambio-carrera-campus-modalidad'
      // },
      // {
      //   isTemp: false,
      //   procedureId: 1030,
      //   name: 'Emisión de carné universitario',
      //   url: 'emision-carnet-universitario'
      // }
    ]
  },
  scholarships: {
    id: 3,
    url: 'becas-descuentos',
    name: 'BECAS',
    title: 'Becas y descuentos',
    procedureList: [
      {
        isTemp: false,
        name: 'Beca socioeconómica',
        procedureId: 1013,
        url: 'bse'
      }
    ]
  }
};

const procedureStatus = {
  updatePhoto: [
    { name: 'PENDIENTE', isComplete: false, isApproved: null },
    { name: 'PROCEDE', isComplete: true, isApproved: true },
    { name: 'NO_PROCEDE', isComplete: true, isApproved: false },
    { name: 'ANULADO', isComplete: false, isApproved: false }
  ],
  removeFromPeriod: [
    { name: 'PENDIENTE', isComplete: false, isApproved: null },
    { name: 'PROCEDE', isComplete: true, isApproved: true },
    { name: 'NO_PROCEDE', isComplete: true, isApproved: false },
    { name: 'ANULADO', isComplete: false, isApproved: false }
  ],
  changeCareerCampusModality: [
    { name: 'CREADO', isComplete: false, isApproved: null },
    { name: 'PAGO_ACTIVADO', isComplete: false, isApproved: null },
    { name: 'PAGO_REALIZADO', isComplete: false, isApproved: null },
    { name: 'PROCEDE', isComplete: true, isApproved: true },
    { name: 'NO_PROCEDE', isComplete: true, isApproved: false },
    { name: 'ANULADO', isComplete: true, isApproved: false }
  ],
  issuanceCarnetCard: [
    { name: 'CREADO', isComplete: false, isApproved: null },
    { name: 'PAGO_ACTIVADO', isComplete: false, isApproved: null },
    { name: 'PAGO_REALIZADO', isComplete: false, isApproved: null },
    { name: 'PROCEDE', isComplete: true, isApproved: true },
    { name: 'NO_PROCEDE', isComplete: true, isApproved: false },
    { name: 'ANULADO', isComplete: false, isApproved: false }
  ],
  certificateOfStudies: [
    { name: 'CREADO', isComplete: false, isApproved: null },
    { name: 'PAGO_ACTIVADO', isComplete: false, isApproved: null },
    { name: 'PAGO_REALIZADO', isComplete: false, isApproved: null },
    { name: 'FINALIZADO', isComplete: true, isApproved: true },
    { name: 'ANULADO', isComplete: false, isApproved: false }
  ],
  certificatesType01: [
    { name: 'CREADO', isComplete: false, isApproved: null },
    { name: 'PAGO_ACTIVADO', isComplete: false, isApproved: null },
    { name: 'PAGO_REALIZADO', isComplete: false, isApproved: null },
    { name: 'FINALIZADO', isComplete: true, isApproved: true },
    { name: 'ANULADO', isComplete: false, isApproved: false }
  ],
  reincorporated: [
    { name: 'FINALIZADO', isComplete: true, isApproved: true },
    { name: 'NO_PROCEDE', isComplete: true, isApproved: false },
    { name: 'PENDIENTE', isComplete: false, isApproved: null },
    { name: 'CREADO', isComplete: false, isApproved: null },
    { name: 'PAGO_ACTIVADO', isComplete: false, isApproved: null },
    { name: 'PAGO_REALIZADO', isComplete: false, isApproved: null },
    { name: 'ANULADO', isComplete: false, isApproved: false }
  ],
  examStragglers: [
    { name: 'CREADO', isComplete: false, isApproved: null },
    { name: 'PAGO_ACTIVADO', isComplete: false, isApproved: null },
    { name: 'PAGO_REALIZADO', isComplete: false, isApproved: null },
    { name: 'PROCEDE', isComplete: true, isApproved: true },
    { name: 'NO_PROCEDE', isComplete: true, isApproved: false },
    { name: 'ANULADO', isComplete: false, isApproved: false },
    { name: 'FINALIZADO', isComplete: true, isApproved: true }
  ],
  retreatCourse: [
    { name: 'CREADO', isComplete: false, isApproved: null },
    { name: 'PAGO_ACTIVADO', isComplete: false, isApproved: null },
    { name: 'PAGO_REALIZADO', isComplete: false, isApproved: null },
    { name: 'PROCEDE', isComplete: true, isApproved: true },
    { name: 'NO_PROCEDE', isComplete: true, isApproved: false },
    { name: 'ANULADO', isComplete: false, isApproved: false },
    { name: 'FINALIZADO', isComplete: true, isApproved: true }
  ],
  bse: [
    { name: 'CREADO', isComplete: false, isApproved: null },
    { name: 'PAGO_ACTIVADO', isComplete: false, isApproved: null },
    { name: 'PAGO_REALIZADO', isComplete: false, isApproved: null },
    { name: 'PROCEDE', isComplete: true, isApproved: true },
    { name: 'NO_PROCEDE', isComplete: true, isApproved: false },
    { name: 'ANULADO', isComplete: false, isApproved: false },
    { name: 'FINALIZADO', isComplete: true, isApproved: true }
  ],
  Agreement: [
    { name: 'PENDIENTE', isComplete: false, isApproved: null },
    { name: 'PROCEDE', isComplete: true, isApproved: true },
    { name: 'NO_PROCEDE', isComplete: true, isApproved: false },
    { name: 'ANULADO', isComplete: false, isApproved: false },
    { name: 'FINALIZADO', isComplete: true, isApproved: true }
  ],
  graduatedCertificated: [
    { name: 'CREADO', isComplete: false, isApproved: null },
    { name: 'PAGO_ACTIVADO', isComplete: false, isApproved: null },
    { name: 'PAGO_REALIZADO', isComplete: false, isApproved: null },
    { name: 'PROCEDE', isComplete: true, isApproved: true },
    { name: 'NO_PROCEDE', isComplete: true, isApproved: false },
    { name: 'ANULADO', isComplete: false, isApproved: false },
    { name: 'FINALIZADO', isComplete: true, isApproved: true }
  ]
};

const options = {
  removeFromPeriod: ['Económico', 'Laboral', 'Salud', 'Otros']
};

const urlPagosPortalEstudiante =
  'https://portalestudiante03.utp.edu.pe/Home/Tramites';

const categoryList = [
  {
    categoryId: 4,
    title: 'Autogestionables',
    icon: categoriesItemAutogestionables,
    description:
      'Realiza trámites de forma independiente y optimiza tus gestiones académicas.'
  },
  {
    categoryId: 3,
    title: 'Becas y convenios',
    icon: categoriesItemBecas,
    description:
      'Obtén beneficios para impulsar tu desarrollo académico y profesional.'
  },
  {
    categoryId: 5,
    title: 'Solicitudes SAE',
    icon: categoriesItemRequests,
    description:
      'Envía tus consultas y trámites al Servicio de Atención al Estudiante.'
  }
];

const arrStepsBSE = [
  {
    step: 1,
    disable: false,
    complete: false,
    current: false
  },
  {
    step: 2,
    disable: false,
    complete: false,
    current: false
  },
  { step: 3, disable: true, complete: false, current: true },
  { step: 4, disable: true, complete: false, current: false },
  { step: 5, disable: true, complete: false, current: false }
];

const sectionHeader = {
  title: 'Trámites',
  description:
    'Realiza trámites autogestionables y registra solicitudes en línea.'
};

const listProcedure = [
  ...categories.certificates.type1List,
  ...categories.requests.procedureListTemp,
  ...categories.scholarships.procedureList
];

const paymentsStatusVerification = {
  paid: 'PAGADO',
  pending: 'PENDIENTE',
  partialPay: 'PAGOPARCIAL'
};

export default {
  categories,
  procedureStatus,
  maxSize: 5,
  options,
  urlPagosPortalEstudiante,
  categoryList,
  arrStepsBSE,
  sectionHeader,
  listProcedure,
  paymentsStatusVerification
};
